module.exports = __webpack_public_path__ + "media/landing_page/facebook-cashew-f5af6a5c.svg";